import React from "react";
import chroma from "chroma-js";
import NumberFormat from "react-number-format";
import styles from "./ContinuousColorScaleLegend.module.css";

/**
 * Renders a vertical continuous color scale
 *
 * @param {Object} props
 * @param {string} props.colorStart
 * @param {string} props.colorEnd
 * @param {number} props.min
 * @param {number} props.max
 * @param {string} props.unit
 */
function ContinuousColorScaleLegend(_ref) {
  let {
    colorStart,
    colorEnd,
    min,
    max,
    unit
  } = _ref;
  const nSteps = 100;
  const stepHeight = "1%";
  const tickPositions = [0, 50, 100];
  const colorScale = chroma.scale([colorStart, colorEnd]).mode("lch");
  const colors = colorScale.colors(nSteps);
  return /*#__PURE__*/React.createElement("div", {
    className: styles.colorScaleContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.gradient
  }, colors.reverse().map((c, i) => /*#__PURE__*/React.createElement("span", {
    key: i,
    className: styles.gradientStep,
    style: {
      backgroundColor: c,
      height: stepHeight
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles.ticks
  }, tickPositions.map(pos => /*#__PURE__*/React.createElement("div", {
    key: pos,
    className: styles.tick,
    style: {
      top: `${100 - pos}%`
    }
  }, /*#__PURE__*/React.createElement(NumberFormat, {
    value: (max - min) * pos / 100 + min,
    displayType: "text",
    thousandSeparator: " "
  }), " ", /*#__PURE__*/React.createElement("span", null, unit)))));
}
export default ContinuousColorScaleLegend;